module.exports = __webpack_public_path__ + "static/media/menu-logo-white.dd42fbf7.svg";